import React from 'react';
import { ChevronLeftIcon, PhoneIcon } from 'lucide-react';
export const PhoneVerificationConfirmation = ({
  onBack,
  onNext
}) => {
  return <div className="flex flex-col p-6 flex-grow" data-id="element-407">
      <div className="flex items-center mb-6" data-id="element-408">
        <button onClick={onBack} className="mr-4" data-id="element-409">
          <ChevronLeftIcon size={24} data-id="element-410" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-411">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-412"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-413"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-414"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-415"></div>
        </div>
      </div>
      <div className="flex justify-center mb-6" data-id="element-416">
        <div className="bg-[#eeeeff] p-4 rounded-full" data-id="element-417">
          <PhoneIcon size={32} className="text-[#5c5cf5]" data-id="element-418" />
        </div>
      </div>
      <h1 className="text-2xl font-bold mb-4 text-center" data-id="element-419">
        Thanks for verifying your phone number
      </h1>
      <p className="text-gray-700 mb-6 text-center" data-id="element-420">
        If you get interrupted before completing this application you can pick
        up where you left off. Choose "Resume my Application" and enter that
        phone number.
      </p>
      <div className="bg-gray-100 rounded-lg p-4 mb-6" data-id="element-421">
        <p className="text-gray-700 text-sm" data-id="element-422">
          Your progress is automatically saved. You can come back anytime and
          continue from where you left off.
        </p>
      </div>
      <div className="mt-auto" data-id="element-423">
        <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium" onClick={onNext} data-id="element-424">
          Next
        </button>
      </div>
    </div>;
};